// Mappe une erreur API vers une clé i18n du namespace `auth.errors`.

import { ApiError } from '@/types/api';

const KNOWN = new Set([
  'AUTH_INVALID_CREDENTIALS',
  'AUTH_ACCOUNT_LOCKED',
  'AUTH_ACCOUNT_BLOCKED',
  'AUTH_ACCOUNT_DELETED',
  'EMAIL_NOT_VERIFIED',
  'AUTH_CODE_INVALID',
  'AUTH_CODE_EXPIRED',
  'AUTH_CODE_TOO_MANY_ATTEMPTS',
  'AUTH_EMAIL_ALREADY_VERIFIED',
  'RATE_LIMITED',
]);

// Renvoie la clé (sans le préfixe `errors.`) : un code connu ou `generic`.
export function authErrorKey(e: unknown): string {
  return e instanceof ApiError && KNOWN.has(e.code) ? e.code : 'generic';
}
